import React from 'react';
import Button from './ui/Button';
import Icon from './AppIcon';
import { SERVICE_CLOSED_NOTICE } from '../config/serviceStatus';

const ServiceClosedModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-md rounded-lg bg-card p-6 shadow-card">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <Icon name="Wrench" size={32} color="var(--color-primary)" />
          </div>
          <h2 className="mb-2 text-2xl font-bold text-foreground">
            {SERVICE_CLOSED_NOTICE?.title}
          </h2>
        </div>
        <div className="mb-6 space-y-3 rounded-lg bg-muted/30 p-4">
          {SERVICE_CLOSED_NOTICE?.lines?.map((line, index) => (
            <p key={index} className="text-sm leading-relaxed text-foreground">
              {line}
            </p>
          ))}
        </div>
        <Button variant="default" fullWidth onClick={onClose}>
          확인
        </Button>
      </div>
    </div>
  );
};

export default ServiceClosedModal;
